import { memo, useCallback, useMemo } from 'react';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import {
  FilterOption,
  FilterType
} from 'components/FilterComponents/FilterPopover/types';

import { OfferStatusFilterValue } from '../../OfferFilters.types';

interface IStatusFilterProps {
  selected: OfferStatusFilterValue[];
  onToggle: (value: OfferStatusFilterValue) => void;
}

const STATUS_OPTIONS: FilterOption[] = [
  { label: 'Active', value: OfferStatusFilterValue.ACTIVE },
  { label: 'Inactive', value: OfferStatusFilterValue.INACTIVE }
];

export const StatusFilter = memo(({ selected, onToggle }: IStatusFilterProps) => {
  const handleChange = useCallback(
    (value: string): void => {
      onToggle(value as OfferStatusFilterValue);
    },
    [onToggle]
  );

  const selectedValues = useMemo(() => selected.map(String), [selected]);

  return (
    <FilterPopover
      label="Status"
      filterType={FilterType.CHECKLIST}
      options={STATUS_OPTIONS}
      selectedItems={selectedValues}
      onChange={handleChange}
      dataTestId="offers-status-filter"
      popoverHeight="auto"
    />
  );
});

StatusFilter.displayName = 'StatusFilter';
